/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_How_S3_DescInputs */

const en_landing_how_s3_desc = /** @type {(inputs: Landing_How_S3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download the result, or press "Keep editing this" to make the next change on top of it.`)
};

const zh_landing_how_s3_desc = /** @type {(inputs: Landing_How_S3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下载结果，或点击“继续编辑这张”，在此基础上进行下一处修改。`)
};

/**
* | output |
* | --- |
* | "Download the result, or press \"Keep editing this\" to make the next change on top of it." |
*
* @param {Landing_How_S3_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_how_s3_desc = /** @type {((inputs?: Landing_How_S3_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_How_S3_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_how_s3_desc(inputs)
	return zh_landing_how_s3_desc(inputs)
});
export { landing_how_s3_desc as "landing.how.s3_desc" }